import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealStatusLogEntity } from '../../domain/entities/MealStatusLogEntity'
import type { MealStatusLogAdminDto } from '@/backend/market'

export class MealStatusLogModel extends MealStatusLogEntity {
  constructor(dataDto: MealStatusLogAdminDto) {
    super()
    mapEntityProperties<MealStatusLogEntity>(this, dataDto)
  }
}
